import { generateUUID } from './util';

export const initialConditions = [
  { externalReference: '1', optionOne: 'Strong', optionTwo: 'Headache' },
  { externalReference: '2', optionOne: 'Healthy', optionTwo: 'Diarrhea' },
  { externalReference: '3', optionOne: 'Regular', optionTwo: 'Constipated' },
  { externalReference: '4', optionOne: 'Calm Stomach', optionTwo: 'Nauseous' },
  { externalReference: '5', optionOne: 'Energetic', optionTwo: 'Tired' },
  { externalReference: '6', optionOne: 'Full', optionTwo: 'Hungry' },
  { externalReference: '7', optionOne: 'Clear Head', optionTwo: 'Dizzy' },
  { externalReference: '8', optionOne: 'Normal Limbs', optionTwo: 'Tingling' },
  { externalReference: '9', optionOne: 'Comfortable', optionTwo: 'Hot or Cold' },
  { externalReference: '10', optionOne: 'Healthy Joints', optionTwo: 'Joint Pain' },
  { externalReference: '11', optionOne: 'Healthy Skin', optionTwo: 'Itchy' },
  { externalReference: '12', optionOne: 'Confident', optionTwo: 'Anxious' },
  { externalReference: '13', optionOne: 'Calm', optionTwo: 'Irritated' },
  { externalReference: '14', optionOne: 'Happy', optionTwo: 'Depressed' },
  { externalReference: '15', optionOne: 'Clear Memory', optionTwo: 'Fuzzy Memory' },
  { externalReference: '16', optionOne: 'Focused', optionTwo: 'Distracted' },
  { externalReference: '17', optionOne: 'Rested', optionTwo: 'Foggy Brain' }
];

export const initialRecommendedExercises = [
  {
    externalReference: generateUUID(),
    name: '',
    measurement: '',
    amounts: [{ externalReference: generateUUID(), fromWeek: '', toWeek: '', amount: '' }]
  }
];

export const initialOptionalExercises = [{ externalReference: generateUUID(), name: '', measurement: '' }];

export const initialSelfCareActivities = [{ externalReference: generateUUID(), name: '' }];

export const initialCharityActivities = [
  {
    externalReference: generateUUID(),
    name: '',
    measurement: '',
    amounts: [{ externalReference: generateUUID(), fromWeek: '', toWeek: '', amount: '' }]
  }
];

export const stripEmptyTemplates = (input) => {
  const copy = structuredClone(input);

  const { accountabilityTemplate } = copy;

  if (!accountabilityTemplate) return input;

  accountabilityTemplate.charityTemplates = accountabilityTemplate.charityTemplates?.flatMap((template) =>
    template.name ? [template] : []
  );
  accountabilityTemplate.optionalExercise = accountabilityTemplate.optionalExercise.flatMap((exercise) =>
    exercise.name ? [exercise] : []
  );
  accountabilityTemplate.recommendedExercise = accountabilityTemplate.recommendedExercise.flatMap((exercise) =>
    exercise.name ? [exercise] : []
  );
  accountabilityTemplate.selfCare = accountabilityTemplate.selfCare.flatMap((activity) =>
    activity.name ? [activity] : []
  );

  return copy;
};
